"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.makeConfig = exports.machineJSON = exports.createReviewApptMachine = void 0;
var _xstate = require("xstate");
var _States = require("../../lib/constants/States");
var _Actions = require("../../lib/constants/Actions");
var _api = require("../../lib/api");
var _utils = require("../../lib/utils");
var _gxUtils = require("../../lib/gxUtils");
const actions = {
  setBookedAppt: (0, _xstate.assign)({
    bookedAppt: (ctx, event) => event.data.result
  }),
  sendParentNext: (0, _xstate.sendParent)(ctx => ({
    type: _Actions.NEXT,
    data: {
      bookedAppt: ctx.bookedAppt
    }
  })),
  sendParentRebook: (0, _xstate.sendParent)(() => ({
    type: _Actions.REBOOK
  }))
};
const guards = {
  isBookingDuplicate: (_ctx, e) => {
    const body = e.data.response.data;
    return body.error && body.error.code === 'SLOT_UNAVAILABLE';
  },
  didBookingFail: (_ctx, event) => !event.data || !event.data.result
};
const services = {
  handleBookAppt: ctx => {
    const api = new _api.Api(ctx.customerCode);
    const ehrBoundGXData = (0, _gxUtils.getGXDataForEHR)(ctx.linkedGxAnswers);
    return api.bookAppointment({
      csrfToken: ctx.csrfToken,
      selectedAppointment: ctx.selectedAppointment,
      patientRegistration: ctx.patientRegistration,
      ehrBoundGXData,
      channel: ctx.productName
    });
  }
};
const machineJSON = _ref => {
  let {
    provider,
    selectedAppointment,
    patientRegistration,
    csrfToken,
    customerCode,
    linkedGxAnswers,
    productName
  } = _ref;
  return {
    id: `Machine__${_States.reviewAppt}`,
    initial: _States.idle,
    context: {
      provider,
      selectedAppointment,
      location: (0, _utils.getApptLocation)(provider, selectedAppointment),
      patientRegistration,
      bookedAppt: null,
      csrfToken,
      customerCode,
      linkedGxAnswers,
      productName
    },
    states: {
      [_States.idle]: {
        on: {
          [_Actions.BOOK_APPT]: _States.bookingAppt
        }
      },
      [_States.bookingAppt]: {
        invoke: {
          id: 'handleBookAppt',
          src: 'handleBookAppt',
          onDone: [{
            cond: 'didBookingFail',
            target: _States.error
          }, {
            actions: 'setBookedAppt',
            target: _States.success
          }],
          onError: [{
            cond: 'isBookingDuplicate',
            target: _States.apptUnavailable
          }, {
            target: _States.error
          }]
        }
      },
      [_States.apptUnavailable]: {
        initial: _States.error,
        states: {
          [_States.error]: {
            after: {
              5000: _States.redirecting
            },
            on: {
              [_Actions.REBOOK_DIRECT]: _States.redirecting
            }
          },
          [_States.redirecting]: {
            entry: 'sendParentRebook'
          }
        }
      },
      [_States.success]: {
        entry: 'sendParentNext'
      },
      [_States.error]: {
        on: {
          [_Actions.BOOK_APPT]: _States.bookingAppt
        }
      }
    }
  };
};
exports.machineJSON = machineJSON;
const makeConfig = () => ({
  services,
  actions,
  guards
});
exports.makeConfig = makeConfig;
const createReviewApptMachine = _ref2 => {
  let {
    config = makeConfig(),
    ...props
  } = _ref2;
  return (0, _xstate.Machine)(machineJSON(props)).withConfig(config);
};
exports.createReviewApptMachine = createReviewApptMachine;